var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b2b-page-createcover"},[_c('b2b-steps',{attrs:{"steps":_vm.steps,"active":_vm.active},on:{"update":_vm.nextStep}}),_c('keep-alive',[_c(_vm.returnComponent,{tag:"component",on:{"update":_vm.nextStep}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }